export default "__VITE_ASSET__CZcoQquU__"